<template>
      <h1 v-if="title" class="formheader">{{title}}</h1>
</template>
<script>
    export default {
        props: {
            title: { required: true }
        }
    }
</script>